import React,{useEffect, useState} from 'react'
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import GoogleMapReact from 'google-map-react';
import useCordinates from '../../../hooks/useCordinates';
import axios from 'axios';
import { PinDrop } from '@mui/icons-material';
const apiKey = process.env.REACT_APP_MAP_API_KEY;


const AnyReactComponent = ({ text }) => <div>{text}</div>;

function AddressInputComponent({lat,setLat,lng,setLng,address,setAddress,addressHelper,setAddressHelper}) {
    const [atLocation,setAtLocationStatus] = useState(false);
    const cordinates = useCordinates();

    const [inputValue,setInputValue] = useState(null);

    useEffect(()=>{
        if( cordinates && atLocation){
            console.log(cordinates);
            setLat(cordinates.latitude);
            setLng(cordinates.longitude);
            let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+cordinates.latitude+","+cordinates.longitude+"&key="+apiKey
            axios.get(url).then(res=>{
                console.log("res is ",res.data.plus_code.compound_code);
                setAddress(res.data.plus_code.compound_code);
            })
        } else {
            setLat(null);
            setLng(null);
            setAddress(null);
        }
    },[cordinates,atLocation])

    useEffect(()=>{
        if(inputValue!==null && !atLocation){
            setLat(null);
            setLng(null)
            geocodeByAddress(inputValue.label)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) =>{
                setAddress(inputValue.label)
                setLat(lat)
                setLng(lng);
            });
        }

    },[inputValue])

    return (
        <div className='row'>
            <div className='col-md-12'>
                <button type="button" onClick={()=>setAtLocationStatus(true)}   className={atLocation?  'm-2 btn btn-primary' : 'ms-2 btn btn-outline-primary'}> I am at Location </button>    
                <button type="button" onClick={()=>setAtLocationStatus(false)}  className={!atLocation? 'm-2 btn btn-primary' : 'ms-2 btn btn-outline-primary'}>I am not at location</button>
            </div>

            <div className="col-md-6">
                {!atLocation &&                     
                    <div className="mt-2">
                        <GooglePlacesAutocomplete
                            apiKey={apiKey}
                            selectProps={{
                                placeholder: 'Select Area / Near By Area',
                                onChange:setInputValue
                            }}
                        />
                    </div>                               
                }
            </div>
            <div className='col-md-12'>
                {lat && lng &&
                    <div className='my-3' style={{ height: 400, width: '100%' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "" }}
                            defaultCenter={{lat:lat,lng:lng}}
                            defaultZoom={18}
                        >
                            <AnyReactComponent
                            lat={lat}
                            lng={lng}
                            text={<PinDrop className='text-danger' style={{fontSize:30, position:"absolute",bottom:0, left :-10  }} />}
                            />
                        </GoogleMapReact>
                    </div>   
                }
            </div>
            <div className='col-md-12'>
                <div class="my-3">
                    <label class="form-label">Address</label>
                    <input type="text" className="form-control"
                        placeholder="eg : 100 meter from my location to cross road"
                        value={addressHelper}
                        onChange={(e)=>setAddressHelper(e.target.value)}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddressInputComponent